import { HttpClient } from '@angular/common/http';
// Angular modules.
import { Injectable } from '@angular/core';

// Zenklub services.
import { AvailabilitiesService } from './availabilities.service';
import { EventsService } from './events.service';

@Injectable()
export class NetworkService {
	// Constructor method.
	constructor(
		private http: HttpClient,
		private events: EventsService,
		private availabilities: AvailabilitiesService
	) {}

	// Check if is online.
	checkConnectivity(): boolean {
		return navigator.onLine;
	}

	// Update local db with server data.
	async updateLocalData() {
		await Promise.all([
			this.events.updateLocalEvents({ setWeek: true }),
			this.availabilities.updateLocalBusySlots(),
		]);
	}

	// Keep-alive signal.
	public keepAlive(): void {
		const isConnected: boolean = this.checkConnectivity();
		if (isConnected) {
			this.http.put('professionals/keepAlive', null).subscribe();
		}
	}
}
